import moment from "moment";
import FrontifyIcon from "../../assets/icons/frontify.logo.svg";
import type { CatalogProvider } from "../../api/integrations";

const formatDate = (date: Date) => {
  const dateformt = "M/d/Y h:mma";
  return moment(date).format(dateformt);
};

const getUser = (cred: { admin: boolean }) => {
  if (cred.admin) return "Admin";
  return null;
};

// A managed collection (Frontify) is owned by its platform and is read-only here. An
// integration-fed collection (SKE-3963) only receives files from synced folders and
// stays an ordinary, writable collection, so it is never `isManagedCollection`.
// `feeds` are the providers feeding the collection, from collectionProviders().
const isManagedLibraryCollection = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collection: any,
  feeds: CatalogProvider[] = []
) => {
  if (collection?.frontifyMeta) {
    return {
      isManagedCollection: true,
      isIntegrationFed: false,
      platformName: "Frontify",
      PlatformIcon: FrontifyIcon,
    };
  }

  if (feeds.length > 0) {
    return {
      isManagedCollection: false,
      isIntegrationFed: true,
      platformName: feeds.map((provider) => provider.displayName).join(", "),
    };
  }

  return {
    isManagedCollection: false,
    isIntegrationFed: false,
  };
};

export { formatDate, getUser, isManagedLibraryCollection };
